module.exports = __webpack_public_path__ + "img/runing.9c89f90d.jpeg";